import { render, staticRenderFns } from "./InvoicesAlertsComponent.vue?vue&type=template&id=73253047&"
import script from "./InvoicesAlertsComponent.vue?vue&type=script&lang=js&"
export * from "./InvoicesAlertsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports